import React from 'react';
import { Outlet } from 'react-router';
import { PrivateRoute } from '../../components/PrivateRoute';

export default function UserLayout() {
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  );
}
